import Main from './Playground'
import './style.css'

// eslint-disable-next-line no-unused-vars
const main = new Main((document.querySelector('#mainCanvas') as HTMLCanvasElement))
